export const REQUIRED_FIELD_MESSAGE = "Por favor, preencha esse campo";

export const EMAIL_REGEX =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[\w-]+(?:\.[\w-]+)*$/;

export const PHONE_REGEX = /^\(\d{2}\) \d{4,5}-\d{4}$/;

export const CONTACT_FIELD_VALIDATORS = {
  name: (value: string) => value.trim().length > 0,
  email: (value: string) => EMAIL_REGEX.test(value.trim()),
  phone: (value: string) => PHONE_REGEX.test(value),
} satisfies Record<"name" | "email" | "phone", (value: string) => boolean>;
